var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12850_32898)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12850_32898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2929 12.2929C14.9024 12.6834 14.9024 13.3166 15.2929 13.7071C15.6834 14.0976 16.3166 14.0976 16.7071 13.7071L19.6201 10.7941C19.6351 10.7791 19.6497 10.7637 19.6637 10.748C19.87 10.5648 20 10.2976 20 10C20 9.70241 19.87 9.43521 19.6637 9.25201C19.6497 9.23631 19.6351 9.22091 19.6201 9.20591L16.7071 6.29289C16.3166 5.90237 15.6834 5.90237 15.2929 6.29289C14.9024 6.68342 14.9024 7.31658 15.2929 7.70712L16.5858 9.00001H11C10.4477 9.00001 10 9.44771 10 10C10 10.5523 10.4477 11 11 11H16.5858L15.2929 12.2929Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H12.5C13.8807 20 15 18.8807 15 17.5V14.7326C14.8519 14.647 14.7125 14.5409 14.5858 14.4142C13.9314 13.7598 13.8253 12.7649 14.2674 12H11C9.8954 12 9 11.1046 9 10C9 8.8954 9.8954 8 11 8H14.2674C13.8253 7.23514 13.9314 6.24015 14.5858 5.58579C14.7125 5.4591 14.8519 5.35296 15 5.26738V2.5C15 1.11929 13.8807 0 12.5 0H3Z",
    fill: "#606060"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12850_32898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12850_32898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.645a2f5de9f0fc251aff9dc48d0e335d.svg";
export { ForwardRef as ReactComponent };